import { OffersTypes } from '../types';

export const getOffersDataToSubmit = (offers: OffersTypes | null) => {
  if (!offers?.offerDetails) return undefined;
  const { creditBonus, customerDownPayment, monthlyPayment, term, type, cpoTerm, aprRate } =
    offers.offerDetails;
  const termForCPO = Number((cpoTerm && cpoTerm.match(/\d+$/)?.[0]) || 0);
  const normilizedTerm = type === 'NEW-CAR' || type === 'new' ? term : termForCPO;
  return {
    financeMethod: offers.offerType,
    financeTerm: normilizedTerm ?? 0,
    apr: aprRate,
    amounts: [
      { type: 'downpayment', value: customerDownPayment, description: 'Loan principle amount' },
      { type: 'monthly', value: monthlyPayment, description: 'Loan monthly amount' },
      { type: 'other', value: creditBonus, description: 'Eligible Credit Bonus' },
    ],
  };
};

export const getOffersVehicleDataToSubmit = (offers: OffersTypes | null) => {
  if (!offers) return undefined;

  const { type } = offers.offerDetails;
  const status = type === 'NEW-CAR' || type === 'new' ? 'new' : 'CPO';
  return {
    model: offers?.modelName,
    year: offers?.modelYear,
    trim: offers?.trimName,
    status,
    make: 'Audi',
  };
};
